import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { WhatIs } from "@/components/WhatIs";
import { FranchiseSystem } from "@/components/FranchiseSystem";
import { ProductLines } from "@/components/ProductLines";
import { HowOperator } from "@/components/HowOperator";
import { Problem } from "@/components/Problem";
import { Solution } from "@/components/Solution";
import { Comparison } from "@/components/Comparison";
import { ROI } from "@/components/ROI";
import { HowItWorks } from "@/components/HowItWorks";
import { Authority } from "@/components/Authority";
import { Faq } from "@/components/Faq";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";

export default function LandingPage() {
  useLenis();
  return (
    <div className="relative bg-white text-midnight min-h-screen selection:bg-crimson" data-testid="landing-page">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <main className="relative z-10">
        <Hero />
        <WhatIs />
        <FranchiseSystem />
        <ProductLines />
        <HowOperator />
        <Problem />
        <Solution />
        <Comparison />
        <ROI />
        <HowItWorks />
        <Authority />
        <Faq />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}
